import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

export const canAccessPlaybooks = (): boolean => salesSettingsHelper.isSalesPlaybooksEnabled;
